module.exports = __webpack_public_path__ + "img/press-bg-4.9557146a.svg";